'use client';

/**
 * Generation Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { WhySoftwareSection } from '../common/why-software-section';
import { HowSoftwareWorksSection } from '../common/how-software-works-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { CommissionsSection } from '../common/commissions-section';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';
import { Users, TrendingUp, Target, Award } from 'lucide-react';

interface MLMPlan {
    slug: string;
    name: string;
    description: string;
    content: string;
    image?: string;
    features?: string[];
}

interface PlanDetailContentProps {
    plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <PlanIntroSection
                plan={plan}
                translationNamespace="planDetails.generationPlan.hero"
                imageSrc="/images/mlm-plans/generation_animate.gif"
                descriptionKeys={['description1', 'description2']}
            />
            <WhatIsPlanSection plan={plan} />
            <HowItWorksSection plan={plan} />
            <WhatIsSoftwareSection
                plan={plan}
                translationNamespace="planDetails.generationPlan.whatIsSoftware"
                imageSrc="/images/mlm-plans/mlm-software-demo.webp"
            />
            <HowSoftwareWorksSection plan={plan} translationNamespace="planDetails.generationPlan.howSoftwareWorks" />
            <FeaturesSection plan={plan} translationNamespace="planDetails.generationPlan.features" />
            <CommissionsSection
                plan={plan}
                translationNamespace="planDetails.generationPlan.commissions"
                commissions={[
                    { icon: Users, color: 'primary', titleKey: 'referral.title', descriptionKey: 'referral.description' },
                    { icon: TrendingUp, color: 'blue', titleKey: 'generation.title', descriptionKey: 'generation.description' },
                    { icon: Target, color: 'green', titleKey: 'matching.title', descriptionKey: 'matching.description' },
                    { icon: Award, color: 'purple', titleKey: 'rankAchiever.title', descriptionKey: 'rankAchiever.description' },
                ]}
                gridCols="4"
                hasDescription={true}
            />
            <WhySoftwareSection plan={plan} translationNamespace="planDetails.generationPlan.whySoftware" />
        </div>
    );
}

